module.exports = __webpack_public_path__ + "img/shopfront.28b4b49f.png";